import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbRating } from '@curbnturf/ng-bootstrap/src/lib/rating/rating';

@Component({
  selector: 'curbnturf-rating-display',
  templateUrl: './rating-display.component.html',
  styleUrls: ['./rating-display.component.scss'],
  standalone: true,
  imports: [NgbRating, NgIf],
})
export class RatingDisplayComponent {
  @Input() rating: number;
  @Input() count: number;
  @Input() primary: boolean = true;
}
